module.exports = __webpack_public_path__ + "assets/img/slat_close3.3c95524b.svg";